import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { Document, Page } from "react-pdf";

// Định nghĩa interface cho props của TermsModal
interface TermsModalProps {
  isOpen: boolean; // Trạng thái hiển thị modal
  onClose: () => void; // Callback để đóng modal
}

/**
 * Component TermsModal hiển thị các điều khoản sử dụng dịch vụ Wi-Fi trong một popup.
 * Chỉ hiển thị khi isOpen là true.
 */
const TermsModal: React.FC<TermsModalProps> = ({ isOpen, onClose }) => {
  const intl = useIntl(); // Sử dụng useIntl để lấy hàm formatMessage
  const [numPages, setNumPages] = useState<number>(0);
  const [containerWidth, setContainerWidth] = useState<number>(800); // default
  const containerRef = useRef<HTMLDivElement>(null);

  // Auto-resize PDF width based on container
  useEffect(() => {
    const resize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    resize();
    window.addEventListener('resize', resize);

    return () => {
      window.removeEventListener('resize', resize);
    };
  }, []);


  // Nếu modal không được mở, trả về null để không render gì
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-3 rounded-lg shadow-lg max-w-lg w-full max-h-[80vh] overflow-y-auto m-3">
        {/* Tiêu đề modal */}
        <h2 className="text-xl font-bold mb-4 text-gray-800">{intl.formatMessage({ id: "termsModal.title" })}</h2>

        {/* Nội dung điều khoản */}
        <div className="text-gray-700 space-y-4 text-start">
          <p>
            <strong className="font-semibold">{intl.formatMessage({ id: "termsModal.acceptTermsTitle" })}</strong> {intl.formatMessage({ id: "termsModal.acceptTerms" })}
          </p>
          <p>
            <strong className="font-semibold">{intl.formatMessage({ id: "termsModal.purposeTitle" })}</strong> {intl.formatMessage({ id: "termsModal.purpose" })}
          </p>
          <p>
            <strong className="font-semibold">{intl.formatMessage({ id: "termsModal.privacyTitle" })}</strong> {intl.formatMessage({ id: "termsModal.privacy" })}
          </p>
          <p>
            <strong className="font-semibold">{intl.formatMessage({ id: "termsModal.liabilityTitle" })}</strong> {intl.formatMessage({ id: "termsModal.liability" })}
          </p>
          <p>
            <strong className="font-semibold">{intl.formatMessage({ id: "termsModal.prohibitedActionsTitle" })}</strong> {intl.formatMessage({ id: "termsModal.prohibitedActions" })}
          </p>
          <p>
            <strong className="font-semibold">{intl.formatMessage({ id: "termsModal.changesTitle" })}</strong> {intl.formatMessage({ id: "termsModal.changes" })}
          </p>
          <p>
            <strong className="font-semibold">{intl.formatMessage({ id: "termsModal.contactTitle" })}</strong> {intl.formatMessage({ id: "termsModal.contact" })}
          </p>
        </div>

        {/* <div
          ref={containerRef}
          className="flex-1 overflow-y-auto border rounded"
        >
          <Document
            file="/terms.pdf"
            onLoadSuccess={({ numPages }) => setNumPages(numPages)}
            loading="Đang tải điều khoản..."
            className="p-4"
          >
            {Array.from(new Array(numPages), (_, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                width={containerWidth - 16} // -16 for padding
                renderTextLayer={true}
                renderAnnotationLayer={true}
                className="my-4 mx-auto"
              />
            ))}
          </Document>
        </div> */}

        {/* Nút đóng modal */}
        <div className="mt-6 flex justify-end">
          <button onClick={onClose} className="px-4 py-2 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 transition duration-200">
            {intl.formatMessage({ id: "termsModal.close" })}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
